<template>
  <div :class="{ town_active: visible }">
    <div class="town__fade" />
    <div class="town-popup">
      <div
        class="town__close"
        @click="hide"
      >
        <svg
          width="20px"
          height="20px"
        >
          <use xlink:href="#icon-close" />
        </svg>
      </div>
      <div class="town-popup__top">
        <div class="field-input">
          <label class="town-popup__label">
            <span>
              Выберите ваш город
            </span>
            <input
              ref="inputSearchCity"
              v-model="searchQuery"
              placeholder="Поиск города"
              type="text"
              class="field-input__inner"
            >
          </label>
        </div>
      </div>
      <div
        v-if="visible"
        class="town-popup__bottom"
      >
        <ul class="town-popup__list town-popup__county-list">
          <li
            v-for="countryItem in countries"
            :key="countryItem.name"
            :class="{'town-popup__item_active': countryCodeSelect === countryItem.code}"
            class="town-popup__item"
            @click="countryCodeSelect = countryItem.code"
          >
            {{ countryItem.name }}
            <svg
              v-if="countryCodeSelect === countryItem.code && !searchQuery"
              class="town-popup__arrow"
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
            >
              <path
                d="M1 1L6 6L1 11"
                stroke="#ED1651"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span
              v-if="searchQuery"
              class="town-popup__country-count"
            >
              {{ getCountryCount(countryItem.code) }}
            </span>
          </li>
        </ul>
        <div
          :key="countryCodeSelect"
          class="town-popup__cities-wrap"
        >
          <div class="town-popup__cities-inner">
            <div
              v-if="countryListSelect.citiesPopular && countryListSelect.citiesPopular.length && !searchQuery"
              class="town-popup__list-wrap"
            >
              <h4 class="town-popup__popular-title">
                Популярные города
              </h4>
              <ul class="town-popup__list">
                <li
                  v-for="cityItem in countryListSelect.citiesPopular"
                  :key="cityItem.Code"
                  :class="{'town-popup__item_active': activeCity.Code === cityItem.Code}"
                  class="town-popup__item town-popup__item_city"
                  @click="select({ Name: cityItem.Name, Code: cityItem.Code })"
                >
                  {{ cityItem.Name }}
                </li>
              </ul>
            </div>
            <div
              v-for="(cities, letter) in countryListSelect.citiesByLetter"
              :key="letter"
              class="town-popup__list-wrap"
              :class="{'town-popup__list-wrap_query': searchQuery}"
            >
              <h3
                v-if="!searchQuery"
                class="town-popup__letter"
              >
                {{ letter }}
              </h3>
              <ul class="town-popup__list">
                <li
                  v-for="cityItem in cities"
                  :key="cityItem.Code"
                  :class="{'town-popup__item_active': activeCity.Code === cityItem.Code}"
                  class="town-popup__item town-popup__item_city"
                  @click="select({ Name: cityItem.Name, Code: cityItem.Code })"
                >
                  <template v-if="cityItem.Country_code !== COUNTRY_CODE_RUSSIA">
                    {{ cityItem.Name }}
                  </template>
                  <template v-else>
                    <span class="town-popup__item-city">
                      {{ cityItem.Name }}
                    </span>
                    <span class="town-popup__item-region">
                      {{ cityItem.Region }} {{ cityItem.Region_prefix }}
                    </span>
                  </template>

                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import { getters as cityRepositoryGetters, actions as cityRepositoryActions } from '../../store/city.repository';
import { getters as cityGetters } from '../../store/city.store';
import { COUNTRY_CODES } from '../../helpers/constans';

const CitySelect = {
  name: 'CitySelect',

  data() {
    return {
      searchQuery: '',
      userSelectedCity: null,
      visible: false,
      countryCodeSelect: COUNTRY_CODES.RUSSIA,
    };
  },
  computed: {
    ...cityRepositoryGetters, // cities()
    ...cityGetters,
    /**
       * @TODO: Отложенная фильтрация коллекции городов
       * @returns Array
       */
    filteredCities() {
      return cityRepositoryActions.sort(this.searchQuery
        ? cityRepositoryActions.search(this.searchQuery)
        : cityRepositoryGetters.cities(), 'Name');
    },
    countryList() {
      const countryList = {};
      this.countries.forEach((item) => {
        const cities = this.filteredCities.filter((citie) => citie.Country_code === item.code);
        const citiesByLetter = {};
        const citiesPopular = [];
        cities.forEach((cityItem) => {
          const letter = cityItem.Name.charAt(0).toUpperCase();
          if (!citiesByLetter[letter]) {
            citiesByLetter[letter] = [];
          }
          citiesByLetter[letter].push(cityItem);

          const cityName = cityItem.Name;
          switch (cityName) {
            case 'Москва': citiesPopular[0] = cityItem;
              break;
            case 'Санкт-Петербург': citiesPopular[1] = cityItem;
              break;
            case 'Екатеринбург': citiesPopular[2] = cityItem;
              break;
            case 'Новосибирск': citiesPopular[3] = cityItem;
              break;
            case 'Минск':
            case 'Нур-Султан':
              citiesPopular.push(cityItem);
              break;
            default:
          }
        });

        countryList[item.code] = {
          ...item,
          cities,
          citiesByLetter,
          citiesPopular,
        };
      });
      return countryList || {};
    },
    countryListSelect() {
      return this.countryList[this.countryCodeSelect] || {};
    },
    activeCity() {
      return this.userSelectedCity || { Code: cityGetters.code(), Name: cityGetters.name() };
    },
  },
  beforeCreate() {
    this.COUNTRY_CODE_RUSSIA = COUNTRY_CODES.RUSSIA;
  },
  methods: {
    hide() {
      this.visible = false;
      this.$emit('hide');
    },
    show() {
      this.visible = true;
    },
    select(city, silent) {
      this.userSelectedCity = city;
      if (!silent) {
        this.$emit('select', city);
        this.$root.$emit('cityChanged', city);
      }
    },
    getCountryCount(countryCode) {
      if (!this.countryList[countryCode] || !this.countryList[countryCode].cities) return 0;
      return this.countryList[countryCode].cities.length;
    },
  },
  mounted() {
    cityRepositoryActions.load();
  },
};

const factory = function () {
  const container = document.createElement('div');

  document.body.appendChild(container);

  const instance = new Vue({
    ...CitySelect,
    propsData: { visible: false },
  });

  instance.$mount(container);

  return instance;
};

export { CitySelect as default, factory };

</script>

<style lang="scss" scoped>
  .field-input__inner {
    border: none;
  }

  .layouts__container.calculator-map-modal__container {
    box-shadow: none;
  }
</style>
